<template lang="pug">
.skimmer.shown(v-if="folderList", :class="{ 'nudge-right': insightsShown, 'fit-to-screen': roboWeaveShown, 'focus-mode': focusMode }")
  //-.skimmer.shown(:class="{ shown: skimmerShown }")
  //-.close(@click="toggleSkimmer")
  .controls
    sorter.hide-az(path="skimmerSort", :five="true")
    button-tab.white.right.abs-right#folderAge
      template(slot="title") age
      template(slot="content")
        .reset(@click="reset('FolderAge')")
        .age
          slider(v-model="folderAge",
            :max="10",
            :tooltip="'none'",
            :marks="true",
            :piecewiseLabel="true",
            v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' } }")
          .info.tweet-age in months
          .info in quarters
  .wrap
    .items(v-if="Object.keys(items || {}).length")
      .item(v-for="(id, index) in Object.keys(items)",
            :id="id",
            :class="{ selected: folderDoco && id === folderDoco }",
            v-lazy:background-image="`https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png`",
            :img="`https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png`",
            :did="id",
            @mouseenter.once="prefetchInsights",
            NOTmousemove="zoomDoc",
            @click.stop="click(id)") &nbsp;
        .magnifying-glass(@mouseenter="zoomDoc")
    .no-items(v-else) No documents in this folder match your criteria
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import vueSliderComponent from 'vue-slider-component';
import sorter from '@/components/sorter';
import buttonTab from '@/components/topo-components/button-tab';
let zoomTimer;
export default {
  name: 'folder',
  computed: {
    ...mapGetters(['customThemes', 'selectedThemes', 'documentsSort', 'skimmerSort', 'roboWeaveShown', 'folderAgeQuantiles']),
    ...vuexComputed('folderList', 'folderDoco', 'insightsDoco', 'insightsShown', 'pdf', 'folderAge', 'folderZoomedDoc', 'forceLoader', 'focusMode'),
    items() {
      const { selectedThemes, customThemes, folderList, skimmerSort, folderAgeQuantiles } = this;
      const selectedThemesKeys = Object.keys(selectedThemes || {});
      const { length } = selectedThemesKeys;
      return filter();
      function filter() {
        // console.log('items filter 2', (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        //     .reduce((all, [did, doc]) => {
        //       all[did] = doc;
        //       return all;
        //     }, {}));
        //return (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
        const sorters = (length && {
          Weight: (a, b) => totalWeights(b[1], 'w') - totalWeights(a[1], 'w'),
          vis: (a, b) => totalWeights(b[1], 'v') - totalWeights(a[1], 'v'),
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => totalWeights(b[1], 'p') - totalWeights(a[1], 'p'),
          neg: (a, b) => totalWeights(b[1], 'n') - totalWeights(a[1], 'n')
        }) || {
          Weight: (a, b) => b[1].w - a[1].w,
          vis: (a, b) => b[1].v - a[1].v,
          age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
          pos: (a, b) => b[1].p - a[1].p,
          neg: (a, b) => b[1].n - a[1].n
        };
        return (Object.entries(folderList || {}) || [])
          .filter(([did, { th, tg }]) => {
            //console.log('did', did, hasThemes(selectedThemes, th, customThemes, tg));
            return !length || hasThemes(selectedThemes, th, customThemes, tg);
          })
          .filter(([did, { ageq }]) => {
            return folderAgeQuantiles.includes(ageq);
          })
          .sort(sorters[skimmerSort])
          .reduce((all, [did, doc]) => {
            all[did] = doc;
            return all;
          }, {});
      }
      function totalWeights(item, prop) {
        return selectedThemesKeys.reduce((total, theme) => total + item.themes[theme]?.[prop] || 0, 0);
      }
      function hasThemes(selectedThemes, th, customThemes, tg) {
        //Object.keys(selectedThemes);
        const cts = Object.keys(selectedThemes || {}).filter(k => k / 1).map(k => customThemes[k]);
        //console.log(4232, cts, th?.join(', '), th?.some(t => selectedThemes[(t || '').replace(/\s/, '-')]));
        //console.log(4232, cts, Object.keys(selectedThemes || {}).join(', '), '\n\n', th?.join(', '), th?.some(t => selectedThemes[t]));
        return th?.some(n => selectedThemes[n]) || cts?.some(ct => hasKeywords(ct, tg));
        function hasKeywords({ selectedTags, andOr }, tg) {
          let r = true;
          const keys = Object.keys(selectedTags || {});
          //console.log('hasKeywords', keys, tg?.join(', '));
          //todo: aliases
          if (andOr === 'and') {
            keys.forEach(tag => {
              r = r && tg?.includes(tag);
            });
          } else if (andOr === 'or') {
            if (keys.length) {
              r = tg?.some(n => selectedTags[n]);
            }
          } else {
            keys.forEach(tag => {
              r = r && !tg?.includes(tag);
            });
          }
          return r;
        }
        //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
        //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
      }
    }
  },
  methods: {
    ...mapActions(['loadDoco', 'loadInsights', 'removeLoader']),
    async prefetchInsights({ target, clientX, clientY }) {
      const { loadInsights, zoomDoc } = this;
      //zoomDoc({ target, clientX, clientY });
      console.log('prefetchInsights', target.getAttribute('id'));
      await loadInsights({ id: target.getAttribute('id') });
    },
    zoomDoc({ target, clientX, clientY }) {
      clearTimeout(zoomTimer);
      zoomTimer = setTimeout(() => {
        const { folderZoomedDoc } = this;
        const t = target.getAttribute('id') && target || target.parentNode;
        const id = t.getAttribute('id');
        if (folderZoomedDoc.id !== id) {
          const img = t.getAttribute('img');
          const { top, left, width, height } = t.getBoundingClientRect();
          const { scrollY, scrollX } = window;
          //console.log('zoomDoc top left', top, left, scrollY, scrollX);
          // todo: window edge detection
          this.folderZoomedDoc = { top: top + scrollY, left: left + scrollX, width, height, img, id, clientX, clientY };
        }
      }, 500);
    },
    async click(id) {
      console.log('openInsights', id);
      //this.doco = id;
      this.folderDoco = id;
      this.insightsDoco = id;
      await this.loadInsights({ id });
      this.insightsShown = true;
      this.loadDoco(id);
      //this.pdf = `https://d23xtmsrsmj88h.cloudfront.net/documents/${ id || 'no did' }-1.pdf`;
      console.log('openInsights done', id);
      //this.loadDoco(id);
    },
    reset(type) {
      this.$store.dispatch('reset' + type);
    }
  },
  components: { slider: vueSliderComponent, sorter, buttonTab },
  mounted() {
    // if (pg() && !this.focusMode) {
    if (pg()) {
      window.scrollBy({
        behavior: 'smooth',
        top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 50
        // top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 620
      });
      this.forceLoader = false;
    }
    this.removeLoader();
    function pg() {
      return (/[\?\;\&]pg\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
    }
  }
};
// function copy(src) {
//   try {
//     const img = document.createElement('img');
//     img.src = src;
//     document.body.appendChild(img);
//     let myRange;
//     if (document.createRange) {
//       myRange = document.createRange();
//       myRange.setStartBefore(img);
//       myRange.setEndAfter(img);
//       myRange.selectNode(img);
//     }
//     else
//     {
//       console.log('clipboard not supported');
//     }
//     /*
//     if (document.body.createControlRange)
//     {
//       console.log('ControlRange work');
//       const controlRange = body.createControlRange();
//       controlRange.add(img);
//       controlRange.execCommand('Copy', false, null);
//     }
//     else
//     {
//       console.log('ControlRange NOT work');
//     }
//     */
//     window.getSelection().addRange(myRange);
//     const success = document.execCommand('copy');
//     console.log(success && 'success' || 'fail');
//     document.body.removeChild(img);
//     //document.getElementById('answer').innerHTML="Copy image command was " + msg ;
//   } catch (ex) {
//     console.log('copyImage fail');
//   }
// }
</script>
<style lang="scss" scoped>
@import '../scss/global';
.skimmer {
  //display: ;
  /*position: fixed;
  top: 5rem;
  bottom: 1rem;
  //left: 21vw;
  left: 51vw;
  //width: 76vw;
  width: 46vw;*/
  position: relative;
  max-width: 100vw;
  //max-height: 80vh;
  //overflow: auto;
  background-color: white;
  //box-shadow: 1px 1px 3px black;
  //border-radius: 0.25rem;
  transform: translate3d(-110vw, 0, 0);
  transform-origin: top left;
  transition: transform 500ms ease-in-out;
  will-change: transform;
  //z-index: -1;
  cursor: default;
  //transform: none;
  padding: 3rem 1rem 0;
  &.shown {
    transform: none;
  }
  &.nudge-right {
    margin-left: 21vw;
  }
  &.focus-mode {
    padding-top: 0.5rem;
    //margin-top: 23rem;
    & > .controls {
      display: none;
    }
    .items {
      //padding-left: 4rem;
      padding-bottom: 0.5rem;
      grid-template-columns: repeat(30, 1fr);
      &::before {
        position: relative;
        top: 1.125rem;
        content: 'all documents';
        white-space: nowrap;
        font-family: 'Assistant', sans-serif;
        font-size: 0.8rem;
        text-transform: uppercase;
        color: rgba($brn, 0.5);
        padding-right: 0.5rem;
      }
      .item {
        padding-top: 80%;
        .magnifying-glass {
          font-size: 1rem;
        }
      }
    }
  }
  &.fit-to-screen {
    //max-height: 80vh;
    //overflow: hidden;
  }
  & > .controls {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-start;
  }
  //&.open {
  .wrap {
    max-height: 80vh;
    overflow: auto;
  }
  .items {
    display: grid;
    pointer-events: all;
    /*grid-template-columns: repeat(5, 20%);*/
    grid-template-columns: repeat(10, 1fr);
    //grid-template-columns: repeat(4, 1fr);
    //grid-template-columns: repeat(7, 1fr);
    //overflow: auto;
    //max-height: calc(100vh - 6rem);
    box-sizing: border-box;
    padding-bottom: 2rem;
    .item {
      display: block;
      //width: 6rem;
      margin: 0.25rem;
      //display: none;
      //width: 3rem;
      padding-top: 125%;
      background: white no-repeat center;
      background-size: contain;
      outline: 2px solid #dadada;
      position: relative;
      //box-shadow: 1px 1px 3px black;
      cursor: pointer;
      //outline: 1px solid black;
      transition: transform 250ms ease-in-out;
      will-change: transform;
      transform-origin: center;
      &:hover {
        .magnifying-glass {
          opacity: 1;
          pointer-events: all;
        }
        //z-index: 1;
        //transform: scale(3);
      }
      //&.drop-target {
      //  transform: translate3d(1.5rem, 0, 0);
      //  &::before {
      //    content: '\00a0';
      //    position: absolute;
      //    top: 0;
      //    left: -1rem;
      //    height: 100%;
      //    width: 0.25rem;
      //    background-color: $brn;
      //  }
      //}
      &.selected {
        //pointer-events: none;
        display: block;
        outline: 2px solid orange;
        /*box-shadow: 1px 1px 3px black,
                    1px 1px 6px black,
                    1px 1px 9px black;*/
      }

      //&.selected {
      //  pointer-events: all;
      //  box-shadow: 1px 1px 5px black;
      //}
      &.heading {
        grid-column-start: 1;
        grid-column-end: 6;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #efefef;
        border-bottom-color: $brn;
        border-bottom-width: 2px;
        outline: none;
        padding-top: 0;
        margin: 1.5rem 0 0.25rem;
        font-weight: 500;
        //color: white;
        color: $brn;
        font-size: 2rem;
        /*text-shadow: 0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn,
                     0 0 1px $brn;*/
        -webkit-font-smoothing: antialiased;
        input {
          width: 100%;
          // height: 2rem;
          font-weight: 250;
          font-size: 2rem;
          text-align: center;
          color: $brn;
          outline: none;
          border: none;
        }
      }
    }
  }
  .no-items {
    padding: 4rem;
    font-size: 3rem;
  }
  .close {
    pointer-events: all;
    display: block;
  }
  .count {
    display: none;
  }
  //}
  .count {
    position: absolute;
    top: 0;
    left: 100%;
    transform: translate3d(0.5rem, 0, 0);
  }
  .close {
    display: none;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    height: 3rem;
    width: 3rem;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      color: #dadada;
      cursor: pointer;
      content: '\00d7';
      position: absolute;
      top: -0.3rem;
      right: -0rem;
      font-size: 1.25rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
}
</style>
<style lang="scss">
.skimmer {
  .controls {
    .button-tab {
      &.abs-right {
        position: fixed;
        top: 0.75rem;
        right: 2rem;
        z-index: 5;
        &::after {
          content: 'filter by';
          position: absolute;
          top: -0.6rem;
          right: 100%;
          margin-right: 0.5rem;
          white-space: nowrap;
          font-size: 0.8rem;
          pointer-events: none;
        }
      }
      .age {
        .vue-slider-mark:nth-child(n + 7) {
          .vue-slider-mark-label {
            color: transparent;
            &::after {
              color: #333;
              margin-left: -1rem;
              content: '2';
            }
          }
        }
        .vue-slider-mark:nth-child(n + 8) {
          .vue-slider-mark-label::after {
            content: '3';
          }
        }
        .vue-slider-mark:nth-child(n + 9) {
          .vue-slider-mark-label::after {
            content: '4';
          }
        }
        .vue-slider-mark:nth-child(n + 10) {
          .vue-slider-mark-label::after {
            content: '5';
          }
        }
        .vue-slider-mark:nth-child(n + 11) {
          .vue-slider-mark-label::after {
            content: '6';
          }
        }
      }
      .info {
        position: relative;
        top: 1.5rem;
        font-style: italic;
        color: #aaa;
        text-align: right;
        margin-bottom: 1rem;
        &.tweet-age {
          position: absolute;
          top: 5.625rem;
          left: 37%;
        }
      }
    }
  }
}
</style>
